import { configureStore } from '@reduxjs/toolkit';
import globalReducer from '@/store/global/globalSlice';

import { outagesApi } from '@/apis/outages/outagesApi';
import { sitesApi } from '@/apis/sites/sitesApi';
import { millwrightsApi } from '@/apis/millwrights/millwrightsApi';
import { tasksApi } from '@/apis/tasks/tasksApi';
import { skillsApi } from '@/apis/skills/skillsApi';
import { evaluationsApi } from '@/apis/evaluations/evaluationsApi';
import { workedHoursApi } from '@/apis/workedHours/workedHoursApi';
import { incidentsApi } from '@/apis/incidents/incidentsApi';
import { risksApi } from '@/apis/risks/risksApi';
import { userApi } from '@/apis/user/userApi';
import { errorLoggerMiddleware } from '@/apis/errorLoggerMiddleware';

export const store = configureStore({
  reducer: {
    global: globalReducer,
    [outagesApi.reducerPath]: outagesApi.reducer,
    [sitesApi.reducerPath]: sitesApi.reducer,
    [millwrightsApi.reducerPath]: millwrightsApi.reducer,
    [tasksApi.reducerPath]: tasksApi.reducer,
    [skillsApi.reducerPath]: skillsApi.reducer,
    [evaluationsApi.reducerPath]: evaluationsApi.reducer,
    [workedHoursApi.reducerPath]: workedHoursApi.reducer,
    [incidentsApi.reducerPath]: incidentsApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [risksApi.reducerPath]: risksApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      outagesApi.middleware,
      sitesApi.middleware,
      millwrightsApi.middleware,
      tasksApi.middleware,
      skillsApi.middleware,
      evaluationsApi.middleware,
      workedHoursApi.middleware,
      incidentsApi.middleware,
      risksApi.middleware,
      userApi.middleware,
      errorLoggerMiddleware,
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
